import React from "react";

const Footer = () => {
  return (
    <footer className="p-3 bg-dark text-white text-center sticky-bottom ">
      <p className="lead">Copyright &copy; 2022 Veronica Cheng & Jacky Li</p>
    </footer>
  );
};

export default Footer;
